import * as React from 'react';
import {VideoSettings} from '../video-settings';

import 'font-awesome/css/font-awesome.min.css';
import {
    pane as cssPane,
    rows as cssRows,
    row as cssRow,
    nowBtn as cssNowBtn,
    tourBtn as cssTourBtn,
    showSettings as cssShowSettings,
    local as cssLocal,
} from './tutorial-pane.module.sass';
import {
    placeholderIcon as cssPlaceholderIcon,
    localPlaceholderIcon as cssLocalPlaceholderIcon,
    settings as cssSettings,
    settingsBig as cssSettingsBig,
} from '../video-pane/video-pane.module.sass';
import {isMobile} from '../../utils/helpers';
import {track} from '../../utils/tracker';

export class TutorialPane extends React.Component<any, any> {
    public state = {shouldShowSettings: false};

    public render(): React.ReactElement<any> {
        const {
            showSettings,
            hideSettings,
            props: {startTour, interviewType},
            state: {shouldShowSettings},
        } = this;

        return (
            <div className={cssPane}>
                <div className={cssRows}>
                    <div className={cssRow}>
                        <a
                            className={`btn btn_violet ${cssNowBtn}`}
                            onClick={this.onInstant}
                            href={`/schedule/${interviewType.apiName}/instant`}
                        >Practice a live interview now</a>
                    </div>

                    <div className={cssRow}>
                        <a
                            className={`btn ${cssTourBtn}`}
                            onClick={startTour}
                        >Take the tour again</a>
                    </div>
                </div>

                {!isMobile() &&
                    <div
                        className={`${cssSettings} ${cssSettingsBig} ${cssShowSettings}`}
                        onClick={showSettings}
                    ><i className='fa fa-gear' /></div>
                }

                <div className={cssPlaceholderIcon} />
                <div className={cssLocal}><div className={cssLocalPlaceholderIcon} /></div>

                <VideoSettings
                    context='tutorial'
                    isOpen={shouldShowSettings}
                    onClose={hideSettings}
                    onSave={hideSettings}
                />
            </div>
        );
    }

    private showSettings = () => this.setState({shouldShowSettings: true});
    private hideSettings = () => this.setState({shouldShowSettings: false});

    private onInstant = () => {
        track('tutorial-end', {via: 'instant'});
        track('confirm', {instant: true});
        return true;
    };
}
